import React, {Component} from 'react'
import Field from '../../common/Field'
import i18 from '../../../i18'
import Validator from '../../common/Validator'
import api from '../../../source/api';
import NotificationSystem from 'react-notification-system'

export default class ChangePassword extends Component {

    constructor(props) {
        super()
        this._notificationSystem = null
        this.state = {
            processing: false,
            fields: {
                oldpassword: {value: '', error: '', role: {required: true}},
                newpassword: {value: '', error: '', role: {required: true}},
                confirmpassword: {value: '', error: '', role: {required: true}},
            }
        }
    }

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem
    }

    _addNotification = (msg, type, time = 30) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    changePassword = () => {
        if (this.state.processing) return
        this.setState({processing: true})
        let validator = Validator.validate(this.state.fields)
        if (validator.error) {
            this.setState({
                processing: false,
                fields: validator.fields
            })
            return;
        }

        if (this.state.fields.newpassword.value != this.state.fields.confirmpassword.value) {
            this.setState({processing: false})
            this._addNotification('A jelszó és jelszó megerősítő nem egyezzik meg, kérjük ellenőrizze.', 'error', 10)
            return
        }

        let validPassword = /^(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;
        if (!validPassword.test(this.state.fields.newpassword.value)) {
            this.setState({processing: false})
            this._addNotification('Jelszó minimum 8 karakter hosszú kell legyen, tartalmaznia kell legalább 1 nagybetűt és 1 számot és 1 speciális karaktert pl.: !@#$%^&*', 'error', 10)
            return
        }

        let data = {
            newpassword: this.state.fields.newpassword.value,
            confirmpassword: this.state.fields.confirmpassword.value,
            oldpassword: this.state.fields.oldpassword.value
        }

        api.post('user/changepassword', data)
            .then((response) => {
                if (response.status === 200) {
                    if (response.data.msg == 'INVALID_OLD_PASSWORD') {
                        this._addNotification('Régi jelszó helytelen, kérjük javítsa.', 'error', 10)
                    } else if (response.data.msg == 'PASSWORD_MISMATCH') {
                        this._addNotification('A jelszó és jelszó megerősítő nem egyezzik meg, kérjük ellenőrizze.', 'error', 10)
                    } else {
                        this._addNotification('Jelszó csere sikeresen megtörtént.', 'success', 15)
                    }
                } else {
                    this._addNotification('Jelszó csere sikertelen, kérjük próbálja meg később vagy írjon nekünk.', 'error', 10)
                }
            })
            .catch((err) => {
                this._addNotification('Jelszó csere sikertelen, kérjük próbálja meg később vagy írjon nekünk.', 'error', 10)
            })
        this.setState({processing: false})
    }


    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value
        fields[name].error = error
        this.setState({fields: fields})
    }

    render() {
        return (
            <section id='used-credits'>
                <div className='container'>
                    <div className='row'>
                        <form className='form-vertical'>
                            <div className=''>
                                <Field
                                    type='password'
                                    id='oldpassword'
                                    name='oldpassword'
                                    label='Régi jelszó'
                                    classLabel='control-label'
                                    classInput='form-control bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </div>
                            <br/>
                            <div className=''>
                                <Field
                                    type='password'
                                    id='newpassword'
                                    name='newpassword'
                                    label='Új jelszó'
                                    classLabel='control-label'
                                    classInput='form-control bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </div>
                            <br/>
                            <div className=''>
                                <Field
                                    type='password'
                                    id='confirmpassword'
                                    name='confirmpassword'
                                    label='Jelszó megerősítése'
                                    classLabel='control-label'
                                    classInput='form-control bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </div>
                        </form>
                    </div>
                    <div className='row margin-top-50'>
                        <div className='text-left'>
                            <a onClick={() => this.changePassword()} className={this.state.processing ? 'disabled next-step margin-top-30' : 'next-step margin-top-30'}>{this.state.processing ? i18.BUTTONS._processing : i18.BUTTONS._save}</a>
                        </div>
                    </div>
                </div>
                <NotificationSystem ref='notificationSystem'/>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/profile/changepassword/changepassword.js